import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.jsx';
import './styles/index.css';
import { initAuth } from './lib/auth.js';

initAuth().then((authenticated) => {
  if (!authenticated) return;

  ReactDOM.createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
